export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';

export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const HIDE_GLOBAL_LOADER = 'HIDE_GLOBAL_LOADER';

// add car

export const GET_CN_LOCATION_LIST = 'GET_CN_LOCATION_LIST';
export const SET_CN_LOCATION_LIST = 'SET_CN_LOCATION_LIST';
export const UPDATE_REQUIRED_DOCS_CHECK_LIST = 'UPDATE_REQUIRED_DOCS_CHECK_LIST';

export const ADD_CAR_ELIGIBILITY_REQUEST = 'ADD_CAR_ELIGIBILITY_REQUEST';
export const ADD_CAR_ELIGIBILITY_SUCCESS = 'ADD_CAR_ELIGIBILITY_SUCCESS';
export const ADD_CAR_ELIGIBILITY_FAILURE = 'ADD_CAR_ELIGIBILITY_FAILURE';
export const CLEAR_ADD_CAR_ELIGIBILITY_STATUS = 'CLEAR_ADD_CAR_ELIGIBILITY_STATUS';
export const CLEAR_REFRESH_CAPTCHA_STATUS = 'CLEAR_REFRESH_CAPTCHA_STATUS';

export const ADD_CAR_VIN_CHANGE = 'ADD_CAR_VIN_CHANGE';

export const ADD_CAR_ADDRESS_INPUT_CHANGE = 'ADD_CAR_ADDRESS_INPUT_CHANGE';

export const ADD_CAR_UPLOAD_DOCUMENTS_REQUEST = 'ADD_CAR_UPLOAD_DOCUMENTS_REQUEST';
export const ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS = 'ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS';
export const ADD_CAR_UPLOAD_DOCUMENTS_FAILURE = 'ADD_CAR_UPLOAD_DOCUMENTS_FAILURE';
export const ADD_CAR_UPLOAD_DOCUMENTS_REMOVE = 'ADD_CAR_UPLOAD_DOCUMENTS_REMOVE';

export const ADD_CAR_PROCESS_REQUEST = 'ADD_CAR_PROCESS_REQUEST';
export const ADD_CAR_PROCESS_SUCCESS = 'ADD_CAR_PROCESS_SUCCESS';
export const ADD_CAR_PROCESS_FAILURE = 'ADD_CAR_PROCESS_FAILURE';
export const CLEAR_ADD_CAR_PROCESS_STATUS = 'CLEAR_ADD_CAR_PROCESS_STATUS';

export const GET_SIGNED_TOKEN_REQUEST = 'GET_SIGNED_TOKEN_REQUEST';
export const GET_SIGNED_TOKEN_SUCCESS = 'GET_SIGNED_TOKEN_SUCCESS';
export const GET_SIGNED_TOKEN_FAILURE = 'GET_SIGNED_TOKEN_FAILURE';

export const GET_USER_SIGNED_TOKEN_REQUEST = 'GET_USER_SIGNED_TOKEN_REQUEST';
export const GET_USER_SIGNED_TOKEN_SUCCESS = 'GET_USER_SIGNED_TOKEN_SUCCESS';
export const GET_USER_SIGNED_TOKEN_FAILURE = 'GET_USER_SIGNED_TOKEN_FAILURE';

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const RESET_SIGNED_TOKEN = 'RESET_SIGNED_TOKEN';

export const UPDATE_BILLING_ADDRESS_REQUEST = 'UPDATE_BILLING_ADDRESS_REQUEST';
export const UPDATE_BILLING_ADDRESS_FAILURE = 'UPDATE_BILLING_ADDRESS_FAILURE';
export const UPDATE_BILLING_ADDRESS_SUCCESS = 'UPDATE_BILLING_ADDRESS_SUCCESS';

export const FETCH_BILLING_ADDRESS_INITIAL_REQUEST = 'FETCH_BILLING_ADDRESS_INITIAL_REQUEST';
export const FETCH_BILLING_ADDRESS_REQUEST = 'FETCH_BILLING_ADDRESS_REQUEST';
export const FETCH_BILLING_ADDRESS_SUCCESS = 'FETCH_BILLING_ADDRESS_SUCCESS';
export const FETCH_BILLING_ADDRESS_FAILURE = 'FETCH_BILLING_ADDRESS_FAILURE';
export const BILLING_ADDRESS_MODAL_TOGGLE = 'BILLING_ADDRESS_MODAL_TOGGLE';

// remove car
export const REMOVE_CAR_NEW_OWNER_INFORMATION_CHANGE = 'REMOVE_CAR_NEW_OWNER_INFORMATION_CHANGE';

export const REMOVE_CAR_REQUEST = 'REMOVE_CAR_REQUEST';
export const REMOVE_CAR_SUCCESS = 'REMOVE_CAR_SUCCESS';
export const REMOVE_CAR_FAILURE = 'REMOVE_CAR_FAILURE';

export const CLEAR_REMOVE_CAR_REQUEST_STATUS = 'CLEAR_REMOVE_CAR_REQUEST_STATUS';

export const CONFIRM_TRANSFER_REQUEST = 'CONFIRM_TRANSFER_REQUEST';
export const CONFIRM_TRANSFER_SUCCESS = 'CONFIRM_TRANSFER_SUCCESS';
export const CONFIRM_TRANSFER_FAILURE = 'CONFIRM_TRANSFER_FAILURE';

export const CLEAR_CONFIRM_TRANSFER_REQUEST_STATUS = 'CLEAR_CONFIRM_TRANSFER_REQUEST_STATUS';
